import { render, staticRenderFns } from "./quote-list.vue?vue&type=template&id=0a12805e"
import script from "./quote-list.vue?vue&type=script&lang=js"
export * from "./quote-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports